import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { Select, MenuItem } from '@mui/material';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import { IAppState } from '../../../../state/reducers';
import { resetActiveAsset } from '../../../../state/exchange/activeAsset';
import {
  updateSportFilter,
} from '../../../../state/exchange/searchParams';
import { ControlLabel } from '../styles';
import {
  SportSelectClass,
  SportSelectorContainer,
} from './styles';

class SportSelection extends PureComponent<IProps> {
  handleSportChange = (sport: string) => {
    const {
      onUpdateSportFilter,
      clearActiveAsset,
    } = this.props;
    onUpdateSportFilter(sport);
    clearActiveAsset();
  };

  render() {
    const {
      sports,
      sportFilter,
    } = this.props;

    if (sportFilter === null && sports.length > 0) {
      this.handleSportChange(sports[0]);
    }

    if (sports.length === 1) {
      return <></>;
    }

    return (
      <SportSelectorContainer>
        <ControlLabel>
          Sport:
        </ControlLabel>
        <Select
          className={SportSelectClass}
          onChange={(e) => this.handleSportChange(e.target.value as string)}
          value={sportFilter ?? ''}
          disabled={!sports.length}
          data-auto="SportSelect"
        >
          {sports.map((sport) => (
            <MenuItem key={sport} value={sport}>{sport}</MenuItem>
          ))}
        </Select>
      </SportSelectorContainer>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  sports: state.exchange.searchParams.vendorSports,
  sportFilter: state.exchange.searchParams.sportFilter,
});

const mapDispatchToProps: IDispatchProps = {
  onUpdateSportFilter: updateSportFilter,
  clearActiveAsset: resetActiveAsset,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SportSelection);
